import React, {
  useEffect,
  useState,
} from 'react';

import { communicationAPI } from 'api/communicationAPI';
import SearchIcon from 'assets/images/icon/SearchIcon';
import { cloneDeep } from 'lodash';
import { useRecoilValue } from 'recoil';
import { userInfo } from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import {
  DropdownMenu,
  Overlay,
  Pagenation,
} from 'view/components';
import { CheckBox } from 'view/components/common/CheckBox';
import QnAListItem from 'view/pages/Communication/components/QnAListItem';
import QnApopup from 'view/pages/Communication/components/QnAPopup';
import EmptyBox from "../../../components/common/EmptyBox";
import {classesAPI} from "../../../../api/classesAPI";
import {fadeIn, fadeIn3} from "../../../../styled/StyledComponent";
import SearchInputItem from "../../../components/common/SearchInputItem";

const QnA = (props) => {
      const [qnaList, setQnaLst] = useState([])
      const [list, setList] = useState([]);
      const [reviewList, setReviewList] = useState([]);
      const [classList, setClassList] = useState([]);
      const [loading, setLoading] = useState(false);
      const [selectedData, setSelectedData] = useState(null);
      const [selectClass, setSelectClass] = useState(null);
      const [completed, setCompleted] = useState(true);
      const [received, setRceived] = useState(true);
      const [Popup, setOnPopup] = useState(false);
      const [pageInfo, setPageInfo] = useState({
        totalPages:0,
        number:0,
        size:5,
    })
      const user = useRecoilValue(userInfo);
    
      const getQnAData =  async (pageNumber) => {
        setLoading(true)
          try {
              await communicationAPI.getQnA({
                  params: {
                      classesId: !isEmpty(selectClass?.id) ? selectClass?.id : "",
                      isNew: received === true && completed === true ? "" : received,
                      isCompleted: received === true && completed === true ? "" : !received,
                      paged:true,
                      page:pageNumber,
                      size:5,
                  },
              })
                  .then(res => {
                      setQnaLst(cloneDeep(res?.data?.content))
                      setPageInfo({
                          totalPages:res?.data?.totalPages,
                          number:res?.data?.number,
                          size:res?.data?.size
                      })
                      setLoading(false)
                  })
          }catch (e) {
              setLoading(false)
          }

      }
      const getReviews = async () => {
          await communicationAPI.getReview().then((res) => {
              setReviewList(cloneDeep(res?.data?.content));
          });
      };

    const getClassItem = async () => {
        const result = await classesAPI
            .getClassList({
                params:{
                    size: 100,
                    // progress:categoryParams?.params,
                }
            })
            .then((res) => {
                setClassList(cloneDeep(res?.data?.content));
                return res?.data?.content;
            });
        return result;
    };
    const getClassItems = () => {
        console.log("@user",classList);
        const c = cloneDeep(classList);
        const arr = c
            ?.map((item) => {
                return {
                    ...item,
                    dropdownItem: item?.classTitle || "",
                };
            })
            .filter((filterItem) => {
                return filterItem?.progress === "PUBLISHED";
            });
        return arr || [];
    };
  
      const onClickDropdown = (item: any, key: string, index, obj) => {
          let selectItem;
          console.log("obj", obj);
          if (!isEmpty(obj)) {
              const copy = cloneDeep(obj);
              delete copy.dropdownItem;
              selectItem = copy;
          } else {
              selectItem = item;
          }
          console.log("selectItem", selectItem);
          setSelectClass(cloneDeep(selectItem));
      };
  
      const onClickGetData = (item) => {
          setSelectedData(cloneDeep(item));
  
          setOnPopup(true);
      };

      const onClickMovePage = (isNext) => {
        const c = cloneDeep(pageInfo);
        if(isNext){
            if(pageInfo?.number + 1 === pageInfo?.totalPages) return;
            c.number = c.number + 1
        }else{
            if(pageInfo?.number === 0) return;
            c.number = c.number - 1
        }
        setPageInfo(c);
    };
  
      useEffect(() => {
        getQnAData(0);
      }, [completed, received]);
  
      useEffect(() => {
        getQnAData(0);
      }, [selectClass?.id]);
  
      useEffect(() => {
        getQnAData(pageInfo.number);
      }, [pageInfo.number]);

      useEffect(()=>{
        getClassItem()
      },[])
  
      console.log("list", list);
      console.log("user", user);
      console.log('qnaList', qnaList)
      return (
          <Container>
              {Popup && !isEmpty(selectedData) && (
                    <Overlay filter={true}>
                    <QnApopup
                        getData={()=>{ getQnAData(pageInfo.number);
                          
                      
                        }}
                        data={selectedData}
                        userData={user}
                        onClickPopup={() => {
                            setOnPopup((v) => !v);
                            getQnAData(pageInfo.number);
                        }}
                    />
                </Overlay>
              )}
              {Popup && (
                  <Overlay filter={true}>
                      <QnApopup
                          getData={()=>{ getQnAData(pageInfo.number);


                          }}
                          data={selectedData}
                          userData={user}
                          onClickPopup={() => {
                              setOnPopup((v) => !v);
                              getQnAData(pageInfo.number);
                          }}
                      />
                  </Overlay>
              )}
              <ContentsInner>
                  <StatusCheck>
                      <p>Status:</p>
                      <CheckItem>
                          <CheckBox
                              onClick={() => {
                                  if (received) {
                                      setCompleted(true);
                                  }
                                  setRceived((v) => !v);
                              }}
                              state={received}
                          />
                          <span>New</span>
                      </CheckItem>
                      <CheckItem>
                          <CheckBox
                              onClick={() => {
                                  if (completed) {
                                      setRceived(true);
                                  }
                                  setCompleted((v) => !v);
                              }}
                              state={completed}
                          />
                          <span>Completed</span>
                      </CheckItem>
                  </StatusCheck>
                  <SearchArea style={{ marginBottom: 15 }}>
                      <DropDownArea style={{width:"30%"}}>
                          <DropDownWrap>
                              <DropdownMenu
                                  selected={selectClass?.classTitle || ""}
                                  altText="All classes"
                                  borderColor={"#E5E5E5"}
                                  height={40}
                                  onClick={onClickDropdown}
                                  items={[...getClassItems(), {dropdownItem:"All",}]}
                              />
                          </DropDownWrap>
                          {/*<DropDownWrap*/}
                          {/*    className={"newest"}*/}
                          {/*>*/}
                          {/*    <DropdownMenu*/}
                          {/*        selected={""}*/}
                          {/*        altText="Newest"*/}
                          {/*        borderColor={"#E5E5E5"}*/}
                          {/*        height={40}*/}
                          {/*        items={[]}*/}
                          {/*    />*/}
                          {/*</DropDownWrap>*/}
                      </DropDownArea>
                      <SearchInputItem/>
                  </SearchArea>
  
                  <Wrap>
                      {!isEmpty(qnaList) &&
                          !isEmpty(user) &&
                          qnaList?.map((item, index) => {
                              return (
                                  <ListWrap index={0.3}>
                                      <QnAListItem
                                          userData={user}
                                          onClickPopup={onClickGetData}
                                          data={item}
                                      />
                                  </ListWrap>
                              );
                          })}
                      {
                          isEmpty(qnaList) && loading == false &&
                          <EmptyBox url={"/images/nothing.png"} />
                      }
                  </Wrap>
              </ContentsInner>
              <Pagenation totalPage={pageInfo?.totalPages} 
                onClickMove={(isNext)=>{onClickMovePage(isNext)}}
                size={pageInfo?.size} pageNumber={pageInfo?.number} />
          </Container>
      );
  };
  export default QnA;
  
  const Container = styled.div`
      height: 100%;
      position: relative;
      animation: ${fadeIn} 0.4s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
  `;
  
  const ContentsInner = styled.div`
      padding: 20px;
      overflow: hidden;
      position: relative;
      min-height: 550px;
      height: 100%;
  `;
  
  const Wrap = styled.div`
      scrollbar-width: thin;
      scrollbar-color: transparent transparent;
  
      &::-webkit-scrollbar {
          width: 0;
      }
  
      &::-webkit-scrollbar-thumb {
          background-color: transparent;
      }
  `;
const ListWrap = styled.div<{index?:any}>`
    animation: ${fadeIn3} ${props => props.index}s linear;
`
  const StatusCheck = styled.div`
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      p {
          margin-right: 15px;
          font-weight: 700;
          color: "#333";
          font-size: 18px;
      }
  `;
  const SearchArea = styled.div`
      @media screen and (max-width: 768px) {
          flex-direction: column;
          & > div{
              width: 100%;
          }
      }
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      margin-bottom: 30px;
  `;
  const DropDownArea = styled.div`
      display: flex;
      width: 50%;
      @media screen and (max-width: 768px) {
          width: 100%!important;
          & > div {
              width: 100%!important;
              margin-right: 0!important;
          }
      }
  `;

  const DropDownWrap = styled.div`
      width: 100%;
      margin-right: 15px;
      @media screen and (max-width: 768px) {
          margin-bottom: 16px;
          &.newest{
              margin-right: 0!important;
          }
      }
  `;
  const CheckItem = styled.div`
      span {
          margin-left: 5px;
          font-weight: 400;
          font-size: 18px;
      }
      margin-right: 15px;
      display: flex;
      align-items: center;
  `;
  